import { jsx as t, jsxs as n, Fragment as B } from "react/jsx-runtime";
import { forwardRef as W } from "react";
import { O as z } from "../index-Dlw4JYvo.js";
import { c as o } from "../clsx-OuTLNxxd.js";
import { A as S, a as k } from "../Avatar-DJScF6BI.js";
import { B as L } from "../Button-D6KC5041.js";
import '../OddsButton.css';const O = "320px", q = "600px", w = "1025px", C = "_oddsButton_6qrad_32", N = "_oddsContainer_6qrad_45", v = "_line_6qrad_45", I = "_odds_6qrad_32", D = "_lockedIcon_6qrad_62", M = "_withLine_6qrad_90", A = "_oddsButtonWrapper_6qrad_127", j = "_shouldHideLabelOnMobile_6qrad_138", $ = "_shouldHideLabelOnDesktop_6qrad_151", e = {
  mobile: O,
  "mobile-wide": "480px",
  tablet: q,
  "tablet-wide": "800px",
  desktop: w,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  oddsButton: C,
  oddsContainer: N,
  line: v,
  odds: I,
  lockedIcon: D,
  withLine: M,
  "direction-row": "_direction-row_6qrad_108",
  oddsButtonWrapper: A,
  shouldHideLabelOnMobile: j,
  shouldHideLabelOnDesktop: $
}, F = W(
  ({
    bookieColour: c,
    bookieLogo: a,
    bookieName: s,
    className: r = "",
    flexDirection: h = "column",
    hideBookieLogo: y = !1,
    label: l,
    line: i,
    locked: m = !1,
    odds: g,
    selected: f = !1,
    shouldHideLabelOnDesktop: b = !1,
    shouldHideLabelOnMobile: u = !1,
    wrapperClassName: p = "",
    wrapperStyles: H = {},
    ...d
  }, _) => {
    const x = /* @__PURE__ */ t(
      L,
      {
        className: o(e.oddsButton, r),
        disabled: d.disabled,
        ref: _,
        variant: f ? "secondary" : "default",
        ...d,
        title: s,
        children: m ? /* @__PURE__ */ t(z, { className: e.lockedIcon }) : /* @__PURE__ */ n(B, { children: [
          !y && /* @__PURE__ */ t(S, { size: "small", style: { backgroundColor: c }, children: /* @__PURE__ */ t(k, { alt: `${s} logo`, src: a }) }),
          /* @__PURE__ */ n("div", { className: o(e.oddsContainer, e[`direction-${h}`]), children: [
            i && /* @__PURE__ */ t("span", { className: e.line, children: i }),
            /* @__PURE__ */ t("span", { className: o(e.odds, { [e.withLine]: i }), children: g })
          ] })
        ] })
      }
    );
    return l ? /* @__PURE__ */ n(
      "div",
      {
        className: o(
          e.oddsButtonWrapper,
          {
            [e.shouldHideLabelOnDesktop]: b,
            [e.shouldHideLabelOnMobile]: u
          },
          p
        ),
        style: H,
        children: [
          /* @__PURE__ */ t("p", { children: l }),
          x
        ]
      }
    ) : x;
  }
);
F.displayName = "OddsButton";
export {
  F as OddsButton
};
